<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow title="Modifier une note"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-row>
            <b-col>

              <b-form-group
                v-if="!hospitalizationId"
                id="animal-select"
                label="Animal *"
                label-for="animal-select"
                class="bold-label"
                :invalid-feedback="form.animal.invalidFeedback"
                :state="form.animal.state"
              >
                <AutoCompleteInput
                  id="animal-select"
                  placeholder="Sélectionner un animal"
                  :options="animalOptions"
                  :initValue="this.form.animal"
                  @didSelect="didSelectAnimal"
                  @onReset="animalSelectInvalid = false"
                  :invalid="animalSelectInvalid"
                  invalid-message="Vous devez sélectionner un animal"
                  required
                />
              </b-form-group>

              <b-form-group
                v-if="!hospitalizationId"
                id="hospitalization-select"
                label="Hospitalisation *"
                label-for="hospitalization-select"
                class="bold-label"
                :invalid-feedback="form.hospitalization.invalidFeedback"
                :state="form.hospitalization.state"
              >
                <b-form-select
                  id="hospitalization-select"
                  v-model="form.hospitalization.value"
                  :options="hospitalizationOptions"
                  :state="form.hospitalization.state"
                  :disabled="form.animal.value === null"
                  required
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="title-input"
                label="Titre"
                label-for="title-input"
                class="bold-label"
                :invalid-feedback="form.title.invalidFeedback"
                :state="form.title.state"
              >
                <b-form-input
                  id="title-input"
                  v-model="form.title.value"
                  type="text"
                  maxlength="250"
                  :state="form.title.state"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="bold-label"
                label="Message"
                label-for="description-input"
                :state="form.description.state"
                :invalid-feedback="form.description.invalidFeedback"
              >
                <b-form-textarea
                  id="description-input"
                  class="mt-1"
                  v-model="form.description.value"
                  :state="form.description.state"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

            <b-col>
              <div v-if="note.fileName != null">
                <b-card
                  v-if="note.type === 'PHOTO' && imageSrc"
                  class="mt-2"
                  @click="zoomOnImage(imageSrc)"
                  :img-src="imageSrc"
                  img-alt="Aperçu"
                  overlay
                >
                  <b-card-text>
                    <button @click="removeFile" class="btn-icon remove-photo-icon">
                      <trash-icon/>
                    </button>
                  </b-card-text>
                </b-card>

                <b-card
                  v-if="note.type === 'VIDEO' && videoSrc"
                  class="mt-2"
                  overlay
                >
                  <b-embed
                    type="video"
                    aspect="16by9"
                    controls
                  >
                    <source :src="videoSrc">
                  </b-embed>
                  <b-card-text>
                    <button @click="removeFile" class="btn-icon remove-photo-icon">
                      <trash-icon/>
                    </button>
                  </b-card-text>
                </b-card>


              </div>

              <b-form-group
                v-if="!note.fileName"
                class="bold-label"
                label="Photo ou vidéo"
                label-for="file-input"
                :state="form.file.state"
                :invalid-feedback="form.file.invalidFeedback"
              >
                <b-form-file
                  id="file-input"
                  class="mt-1"
                  accept="image/jpeg, image/png, video/mp4, video/webm, video/quicktime"
                  placeholder="Photo ou vidéo..."
                  drop-placeholder="Glisser le fichier ici"
                  browse-text="Sélectionner"
                  v-model="form.file.value"
                  :state="form.file.state"
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex mt-4 justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Modifier note</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import AutoCompleteInput from "../../components/AutoCompleteInput";

export default {

  name: 'NoteEdit',

  components: {
    BackArrow,
    AutoCompleteInput
  },

  data() {
    return {
      hospitalizationId: this.$route.params.hospitalizationId, // Si l'utilisateur arrive depuis la partie "hospitalisation"
      noteId: this.$route.params.noteId,
      note: null,
      animalSelectInvalid: false,
      sendButtonDisabled: false,

      fileIsRemoved: false,
      imageSrc: null,
      videoSrc: null,

      form: {
        title: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        animal: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        hospitalization: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        description:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        file:{
          state: null,
          invalidFeedback: null,
          value: null,
        }
      },
      animalOptions: [
        { value: null, text: 'Sélectionner un animal' },
      ],
      hospitalizationOptions: []
    }
  },

  mounted(){
    this.fetchData();
  },

  methods: {

    fetchData() {
      this.fetchAnimals()
        .then(this.fetchNote)
    },

    async fetchAnimals(){
      try {
        const response = await api.get(`/animal/getHospitalizedAnimals`)
        response.data.forEach(
          (element) => {
            this.animalOptions.push({value: element.id, text: `${element.name} (${element.user.name})`})
          }
        )
      } catch (e) {
        console.error('fetchAnimals error', e)
      }
    },

    async fetchNote(){
      try {
        const response = await api.get(`/note/${this.noteId}`)
        this.note = response.data
        await this.fetchHospitalizations(this.note.animal.id)

        if (this.note && this.note.fileName && this.note.fileUrl) {
          if (this.note.type === 'PHOTO') {
            await this.loadMediaPreview(this.note.fileUrl, true)
          } else if (this.note.type === 'VIDEO') {
            await this.loadMediaPreview(this.note.fileUrl, false)
          }
        }
      } catch (e) {
        console.error('fetchNote error', e)
      }
    },

    async loadMediaPreview(fileUrl, isPhoto) {
      try {
        const res = await api.get(fileUrl, {
          responseType: 'blob'
        })

        const ct = (res.headers && res.headers['content-type']) || ''

        if (isPhoto && !ct.startsWith('image/')) {
          throw new Error('La réponse n\'est pas une image (content-type=' + ct + ')')
        }

        const blobUrl = window.URL.createObjectURL(res.data)

        if (isPhoto) {
          this.imageSrc = blobUrl
        } else {
          this.videoSrc = blobUrl
        }
      } catch (e) {
        console.error('loadMediaPreview error', e)
      }
    },

    async fetchHospitalizations(animalId) {
      try {
        const response = await api.get(`/hospitalization?animalId=${animalId}`)
        this.hospitalizationOptions = [{ value: null, text: 'Sélectionner une hospitalisation', disabled: true }]
        response.data.map(hospitalization => {
          this.hospitalizationOptions.push({value: hospitalization.id, text: `Hospitalisation du ${new Date(hospitalization.startDate).toLocaleDateString('fr-FR')} (#${hospitalization.id})`})
        })
        this.setInitialValues()
      } catch (e) {
        console.error('fetchHospitalizations error', e)
      }
    },

    setInitialValues() {
      this.form.title.value = this.note.title
      this.form.animal.value = this.note.animal.id
      this.form.hospitalization.value = this.note.hospitalization.id
      this.form.description.value = this.note.description
    },

    didSelectAnimal(value){
      this.form.animal.value = value
      if(value != null) this.fetchHospitalizations(value)
    },

    onSubmit() {
      if(this.form.animal.value === null){
        this.animalSelectInvalid = true
        return
      }
      this.sendButtonDisabled = true

      var headers = { 'content-type': 'multipart/form-data' }

      let data = new FormData()
      if (this.form.title.value && this.form.title.value.trim() !== "") {
        data.append('title', this.form.title.value)
      }
      data.append('hospitalizationId', this.form.hospitalization.value)
      if (this.form.description.value && this.form.description.value.trim() !== "") {
        data.append('description', this.form.description.value)
      }
      if (this.form.file.value) {
        data.append(`file`, this.form.file.value)
      }
      if(this.fileIsRemoved) data.append("fileIsRemoved", this.fileIsRemoved);

      api({
        method: 'POST',
        url: `/note/${this.note.id}`,
        data: data,
        headers: headers
      })
        .then((response) => {
          if (this.hospitalizationId) {
            this.goToNoteForHospitalization()
          } else {
            this.goToNoteShow()
          }
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.description
          }
        });
    },

    successToast(noteTitle) {
      this.$bvToast.toast(`Note ${noteTitle ? noteTitle : ''} modifiée`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    removeFile(){
      this.note.fileName = null
      this.fileIsRemoved = true
      if (this.imageSrc) {
        window.URL.revokeObjectURL(this.imageSrc)
        this.imageSrc = null
      }
      if (this.videoSrc) {
        window.URL.revokeObjectURL(this.videoSrc)
        this.videoSrc = null
      }
    },

    goToNoteShow() {
      this.$router.push({
        name: 'NoteShow',
        params: {
          noteId: this.note.id
        }
      }, () => {
        this.$nextTick(() => {
          this.successToast((this.form.title.value && this.form.title.value.trim() !== "") ? this.form.title.value : null)
        })
      })
    },

    goToNoteForHospitalization() {
      this.$router.push({
        name: 'NoteForHospitalization',
        params: {
          hospitalizationId: this.hospitalizationId
        }
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.form.name.value)
        })
      })
    }
  },

  beforeDestroy() {
    if (this.imageSrc) {
      window.URL.revokeObjectURL(this.imageSrc)
    }
    if (this.videoSrc) {
      window.URL.revokeObjectURL(this.videoSrc)
    }
  }
}
</script>

<style scoped>
.remove-photo-icon {
  position: absolute;
  top: 6px;
  right: 6px;
  background-color: var(--main-red);
  color: var(--main-white);
  border-radius: 50%;
  padding: 5px;
}
.remove-photo-icon:hover {
  background-color: var(--main-red-hover);
}
</style>



// WEBPACK FOOTER //
// src/views/note/NoteEdit.vue